import { isEmpty } from "./isEmpty"

type ConvertToLocaleParams = {
  amount: number
  currency_code: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  locale?: string
}

export const convertToLocale = ({
  amount,
  currency_code,
  minimumFractionDigits,
  maximumFractionDigits,
  locale = "en-US",
}: ConvertToLocaleParams) => {
  return currency_code && !isEmpty(currency_code)
    ? new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency_code,
        minimumFractionDigits,
        maximumFractionDigits,
      }).format(amount)
    : amount.toString()
}

const STRIPE_EXPONENT_OVERRIDES: Record<string, number> = {
  ISK: 2,
  UGX: 2,
}

export const convertMinorToLocale = ({
  amount,
  currency_code,
  ...format
}: ConvertToLocaleParams) => {
  const currency = currency_code.toUpperCase()
  const exponent =
    STRIPE_EXPONENT_OVERRIDES[currency] ??
    new Intl.NumberFormat("en", {
      style: "currency",
      currency,
    }).resolvedOptions().maximumFractionDigits ??
    2

  return convertToLocale({
    amount: amount / 10 ** exponent,
    currency_code,
    ...format,
  })
}
